export type NavigationKey =
  | "operations"
  | "incidents"
  | "assets"
  | "infrastructure"
  | "maintenance"
  | "vendors"
  | "knowledge"
  | "reports"
  | "administration";

export type NavigationItem = {
  key: NavigationKey;
  label: string;
  shortLabel: string;
  group: "primary" | "secondary" | "administrative";
  firstBuild: boolean;
};

export const navigationItems: NavigationItem[] = [
  { key: "operations", label: "Operations", shortLabel: "OP", group: "primary", firstBuild: true },
  { key: "incidents", label: "Incidents", shortLabel: "IN", group: "primary", firstBuild: true },
  { key: "assets", label: "Assets", shortLabel: "AS", group: "primary", firstBuild: true },
  { key: "infrastructure", label: "Infrastructure", shortLabel: "IF", group: "primary", firstBuild: true },
  { key: "maintenance", label: "Maintenance", shortLabel: "MT", group: "primary", firstBuild: true },
  { key: "vendors", label: "Vendors", shortLabel: "VN", group: "secondary", firstBuild: false },
  { key: "knowledge", label: "Knowledge", shortLabel: "KN", group: "secondary", firstBuild: false },
  { key: "reports", label: "Reports", shortLabel: "RP", group: "secondary", firstBuild: false },
  {
    key: "administration",
    label: "Administration",
    shortLabel: "AD",
    group: "administrative",
    firstBuild: false,
  },
];
